var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpgradeProfileBenefits1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_3167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4707 15.75V23.625H13.4119",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8828 49.5L25.7063 49.5L25.7063 40.5",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1172 49.5L32.4113 49.5L32.4113 40.5",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5293 36L52.5293 29.25L43.5881 29.25",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4707 36V29.25H13.4119",
    stroke: "#FF7D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5293 15.75L52.5293 23.625L43.5881 23.625",
    stroke: "#FF7D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94118 14.625C7.94118 16.5642 6.38117 18.125 4.47059 18.125C2.56001 18.125 1 16.5642 1 14.625C1 12.6858 2.56001 11.125 4.47059 11.125C6.38117 11.125 7.94118 12.6858 7.94118 14.625Z",
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9998 14.625C55.9998 16.5642 54.4398 18.125 52.5292 18.125C50.6186 18.125 49.0586 16.5642 49.0586 14.625C49.0586 12.6858 50.6186 11.125 52.5292 11.125C54.4398 11.125 55.9998 12.6858 55.9998 14.625Z",
    fill: "#FF7D23",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94118 37.125C7.94118 39.0642 6.38117 40.625 4.47059 40.625C2.56001 40.625 1 39.0642 1 37.125C1 35.1858 2.56001 33.625 4.47059 33.625C6.38117 33.625 7.94118 35.1858 7.94118 37.125Z",
    fill: "#FF7D23",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9998 37.125C55.9998 39.0642 54.4398 40.625 52.5292 40.625C50.6186 40.625 49.0586 39.0642 49.0586 37.125C49.0586 35.1858 50.6186 33.625 52.5292 33.625C54.4398 33.625 55.9998 35.1858 55.9998 37.125Z",
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7058 49.5C43.7058 51.4392 42.1458 53 40.2352 53C38.3247 53 36.7646 51.4392 36.7646 49.5C36.7646 47.5608 38.3247 46 40.2352 46C42.1458 46 43.7058 47.5608 43.7058 49.5Z",
    fill: "#413D45",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2351 49.5C20.2351 51.4392 18.6751 53 16.7645 53C14.854 53 13.2939 51.4392 13.2939 49.5C13.2939 47.5608 14.854 46 16.7645 46C18.6751 46 20.2351 47.5608 20.2351 49.5Z",
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6467 13.5H22.3525V7.125C22.3525 3.81129 25.0388 1.125 28.3525 1.125H28.6467C31.9604 1.125 34.6467 3.81129 34.6467 7.125V7.3125V7.875",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5293,
    y: 13.5,
    width: 27.9412,
    height: 25.875,
    rx: 4,
    fill: "#FFEADB",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1766 26.4377C30.8553 25.9246 31.2943 25.1076 31.2943 24.1875C31.2943 22.6342 30.0433 21.375 28.5002 21.375C26.957 21.375 25.7061 22.6342 25.7061 24.1875C25.7061 25.1076 26.145 25.9246 26.8237 26.4377V29.8235C26.8237 30.7494 27.5743 31.5 28.5002 31.5C29.4261 31.5 30.1766 30.7494 30.1766 29.8235V26.4377Z",
    fill: "#413D45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_3167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradeProfileBenefits1);
export default __webpack_public_path__ + "static/media/icon-upgrade-profile-benefits-1.35af5aaf34f66a7b0dc74b63724dfd83.svg";
export { ForwardRef as ReactComponent };